exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-title {\n  color: #326792;\n  font-weight: bold;\n  margin: 10px 0px; }\n\n.panel {\n  border-top: #326792 3px solid; }\n\n.report-row {\n  margin: 10px; }\n\n.errors-container {\n  margin: 10px;\n  padding: 10px 0px;\n  border: lightgrey solid 1px; }\n  .errors-container .import-error-icon {\n    color: red;\n    margin-right: 10px; }\n\n.number-tag {\n  width: 30px;\n  height: 30px;\n  border-radius: 5px;\n  color: white;\n  float: left;\n  text-align: center;\n  padding-top: 4px; }\n  .number-tag.tag-pending {\n    background-color: grey; }\n  .number-tag.tag-success {\n    background-color: #13CE66; }\n  .number-tag.tag-error {\n    background-color: red; }\n\n.tag-text-container {\n  height: 30px;\n  padding-top: 4px; }\n  .tag-text-container .tag-text {\n    margin-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/common/import-widget/import-widget.component.scss
// module id = 1108
// module chunks = 7